import React, { useEffect, useState,useRef } from "react";
import "./grid-container.css";
import SectionHeader from "../sectionHeader/sectionHeader";
import Anchor from "../Link/anchor";

const TextGrid = (props) => {
  const mounted = useRef(false);
//   const init = { playlist: [] };
  const [elem, setElem] = useState([]);
  const [felemItem, setFItem] = useState([]);
  const [selemItem, setSItem] = useState([]);
  const [telemItem, setTItem] = useState([]);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplay, setElemDisplay] = useState(true);
//   const history = useHistory();


  useEffect(() => {
    mounted.current = true;
    const ElemDetail = async () => {
      if (mounted.current) {
        setElem(props.information);

      
        setElemDisplay(props.information.devices[0].itemVisibility);
        setFItem(props.information.items);
        let arr = props.information.items;
        let farr = arr.filter(function (el)
        {
          return el.itemType==="First Section"
                 
        }
        );
        let sarr = arr.filter(function (el)
        {
          return el.itemType==="Second Section"
                 
        }
        );
        let tarr = arr.filter(function (el)
        {
          return el.itemType==="Third Section"
                 
        }
        );
        setFItem(farr);
        setSItem(sarr);
        setTItem(tarr);
        isLoading(false);
        SetError(false);

      }
    };

 
   
      ElemDetail();
  
    

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  if (
    elemdisplay &&
    !error &&
    !loading &&
    props.information !== null &&
    props.information !== undefined
  )
  {
    return (
        <section className="new-news-area bg-color-none grid">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab1Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {felemItem !== null
                ? felemItem.map((item, index) => (
                    item.itemid.devices[0].itemVisibility ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
         
                </ul>
              </div>
              <div className="col-sm-12 col-md-4 text-padding">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab2Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {selemItem !== null
                ? selemItem.map((item, index) => (
    
                    item.itemid.devices[0].itemVisibility ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
                </ul>
              </div>
              <div className="col-sm-12 col-md-4 text-padding">
                <div className="clearfix"></div>
                <SectionHeader
                  title={elem.tab3Name}
                  linkTitle={""}
                  link={""}
                  header={true}
                  news={true}
                ></SectionHeader>
    
                <div className="clearfix"></div>
                <ul className="list-space-xs list-square-bullet-exclude-first list-seperated list-unstyled">
                {telemItem !== null
                ? telemItem.map((item, index) => (
                    item.itemid.devices[0].itemVisibility ?
                    <li key={index}>
                    {" "}
                    <article className="post post--horizontal ">
                      <div className="post__text ">
                        <h3 className="post__title typescale-0">
                          <Anchor to={
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            }
                            className={"lighter"}>
                          {item.itemid.mainHeader?item.itemid.mainHeader:item.itemid.displayName?item.itemid.displayName:item.itemid.description}
                          </Anchor>
                        </h3>
                      </div>
                    </article>
                  </li>
                  :""
    
                ))
                :""}
                </ul>
              </div>
            </div>
          </div>
        </section>
      );
  }
  else if (elemdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }

};

export default TextGrid;
